import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFilterTimeline: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFilterTimeline"><Path d="M6.75171 4V17.4387L8.99983 15.1893L10.0608 16.2497L6.00199 20.3107L1.93945 16.2503L2.99983 15.1893L5.25171 17.44V4H6.75171Z" fill="currentColor"/><Path d="M11 6V7.5H21V6H11Z" fill="currentColor"/><Path d="M15 16.5V18H21V16.5H15Z" fill="currentColor"/><Path d="M13 11.25H21V12.75H13V11.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFilterTimeline;
